<template>
  <form name="form" v-on:submit.prevent="submit" v-on:change="changeHandler">
    <fieldset
      :disabled="readonly"
      style="border:0;padding:0;margin:0;min-width:0;"
    >
      <div class="card-body">
        <div class="text-right" v-if="!readonly">
          <form-button :indicator="form.processing()" v-on:clicked="submit">
            Save
          </form-button>
        </div>
        <div class="clearfix"></div>
        <hr />

        <div class="row">
          <div class="col-lg-6">
            <fieldset>
              <legend>
                Recovery
                <small class="text-muted">
                  - Enter the details of recovery
                </small>
              </legend>

              <div
                class="form-group has-helper"
                :class="{ 'has-error': form.errors.has('recovery_at') }"
              >
                <div class="col-md-4">
                  <label class="control-label">Recovery Date:</label>
                  <p class="help-block">
                    Please enter the recovery date
                  </p>
                </div>
                <div class="col-lg-8">
                  <datepicker
                    format="dd/MM/yyyy"
                    :value="form.recovery_at"
                    name="recovery_at"
                    v-on:selected="setRecoveryDate"
                    v-on:input="changeHandler"
                    input-class="form-control"
                    placeholder="dd/mm/yyyy"
                  ></datepicker>
                  <span
                    class="text-danger"
                    v-text="form.errors.get('recovery_at')"
                    v-if="form.errors.has('recovery_at')"
                  ></span>
                </div>
              </div>

              <currency-input
                name="recovery_cost"
                label="Recovery Costs"
                v-model="form.recovery_cost"
                helper="Please enter the recovery cost"
                :show-error="form.errors.has('recovery_cost')"
                :error-message="form.errors.get('recovery_cost')"
              ></currency-input>

              <currency-input
                name="admin_fee"
                label="Admin Fee"
                v-model="form.admin_fee"
                helper="Please enter the admin fee"
                :show-error="form.errors.has('admin_fee')"
                :error-message="form.errors.get('admin_fee')"
              ></currency-input>

              <company-select
                id="recovery-company-select"
                heading="Recovery Company Details"
                :types="companyTypes"
                :company="getRecoveryCompany"
                ref="recoveryCompany"
              ></company-select>
            </fieldset>
          </div>

          <div class="col-lg-6">
            <fieldset>
              <legend>
                Storage
                <small class="text-muted">
                  - Enter the details of storage
                </small>
              </legend>

              <div
                class="form-group has-helper"
                :class="{ 'has-error': form.errors.has('storage_start_at') }"
              >
                <div class="col-md-4">
                  <label class="control-label">Storage start Date:</label>
                  <p class="help-block">
                    Please enter the storage start date
                  </p>
                </div>
                <div class="col-lg-8">
                  <datepicker
                    format="dd/MM/yyyy"
                    :value="form.storage_start_at"
                    name="storage_start_at"
                    v-on:selected="setStorageStartDate"
                    v-on:input="changeHandler"
                    input-class="form-control"
                    placeholder="dd/mm/yyyy"
                  ></datepicker>
                  <span
                    class="text-danger"
                    v-text="form.errors.get('storage_start_at')"
                    v-if="form.errors.has('storage_start_at')"
                  ></span>
                </div>
              </div>
              <div
                class="form-group has-helper"
                :class="{ 'has-error': form.errors.has('storage_end_at') }"
              >
                <div class="col-md-4">
                  <label class="control-label">Storage end date:</label>
                  <p class="help-block">
                    Please enter the storage end date
                  </p>
                </div>
                <div class="col-lg-8">
                  <datepicker
                    format="dd/MM/yyyy"
                    :value="form.storage_end_at"
                    name="storage_end_at"
                    v-on:selected="setStorageEndDate"
                    v-on:input="changeHandler"
                    input-class="form-control"
                    placeholder="dd/mm/yyyy"
                  ></datepicker>
                  <span
                    class="text-danger"
                    v-text="form.errors.get('storage_end_at')"
                    v-if="form.errors.has('storage_end_at')"
                  ></span>
                </div>
              </div>

              <currency-input
                name="storage_daily_rate"
                label="Storage Daily Rate"
                v-model="form.storage_daily_rate"
                helper="Please enter the storage daily rate"
                :show-error="form.errors.has('storage_daily_rate')"
                :error-message="form.errors.get('storage_daily_rate')"
              ></currency-input>

              <currency-input
                name="storage_cap"
                label="Storage Cap"
                v-model="form.storage_cap"
                helper="Please enter the storage cap"
                :show-error="form.errors.has('storage_cap')"
                :error-message="form.errors.get('storage_cap')"
              ></currency-input>

              <fieldset>
                <legend>
                  Storage Location
                  <small class="text-muted">
                    - Enter the storage location
                  </small>
                </legend>
                <address-lookup
                  :address="storageLocation"
                  v-on:address="setStorageLocation"
                ></address-lookup>
              </fieldset>
              <!--            <company-select-->
              <!--                :types="companyTypes"-->
              <!--                :company="getStorageCompany"-->
              <!--                ref="storageCompany"-->
              <!--            ></company-select>-->
            </fieldset>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-6">
            <fieldset>
              <legend>
                Inherited Recovery
                <small class="text-muted">
                  - Enter the details of inherited recovery
                </small>
              </legend>

              <div class="form-group">
                <div class="col-md-4">
                  <label class="control-label">
                    Are there any inherited recovery costs?
                  </label>
                </div>
                <div class="col-md-8">
                  <toggleswitch
                    :labels="true"
                    name="inherited_storage"
                    :checked="hasInheritedRecovery"
                    @change="toggleInheritedRecovery()"
                  ></toggleswitch>
                </div>
              </div>

              <template v-if="hasInheritedRecovery">
                <div
                  class="form-group has-helper"
                  :class="{
                    'has-error': form.errors.has('inherited_recovery_at')
                  }"
                >
                  <div class="col-md-4">
                    <label class="control-label"
                      >Inherited Recovery Date:</label
                    >
                    <p class="help-block">
                      Please enter the inherited recovery date
                    </p>
                  </div>
                  <div class="col-lg-8">
                    <datepicker
                      format="dd/MM/yyyy"
                      :value="form.inherited_recovery_at"
                      name="inherited_recovery_at"
                      v-on:selected="setInheritedRecoveryDate"
                      v-on:input="changeHandler"
                      input-class="form-control"
                      placeholder="dd/mm/yyyy"
                    ></datepicker>
                    <span
                      class="text-danger"
                      v-text="form.errors.get('inherited_recovery_at')"
                      v-if="form.errors.has('inherited_recovery_at')"
                    ></span>
                  </div>
                </div>

                <currency-input
                  name="inherited_recovery_cost"
                  label="Inherited Recovery Costs"
                  v-model="form.inherited_recovery_cost"
                  helper="Please enter the inherited recovery cost"
                  :show-error="form.errors.has('inherited_recovery_cost')"
                  :error-message="form.errors.get('inherited_recovery_cost')"
                ></currency-input>

                <fieldset>
                  <legend>
                    Recovery Address
                    <small class="text-muted">
                      - Enter the recovery address
                    </small>
                  </legend>
                  <address-lookup
                    :address="inheritedRecoveryAddress"
                    v-on:address="setInheritedRecoveryAddress"
                  ></address-lookup>
                </fieldset>

                <company-select
                  id="inherited-recovery-company-select"
                  label="Recovery Company Details"
                  :types="companyTypes"
                  :company="getInheritedRecoveryCompany"
                  ref="inheritedRecoveryCompany"
                ></company-select>
              </template>
            </fieldset>
          </div>

          <div class="col-lg-6">
            <fieldset>
              <legend>
                Inherited Storage
                <small class="text-muted">
                  - Enter the details of inherited storage
                </small>
              </legend>

              <div class="form-group">
                <div class="col-md-4">
                  <label class="control-label">
                    Are there any inherited storage costs?
                  </label>
                </div>
                <div class="col-md-8">
                  <toggleswitch
                    :labels="true"
                    name="inherited_storage"
                    :checked="hasInheritedStorage"
                    @change="toggleInheritedStorage()"
                  ></toggleswitch>
                </div>
              </div>

              <template v-if="hasInheritedStorage">
                <div
                  class="form-group has-helper"
                  :class="{
                    'has-error': form.errors.has('inherited_storage_start_at')
                  }"
                >
                  <div class="col-md-4">
                    <label class="control-label"
                      >Inherited Storage start Date:</label
                    >
                    <p class="help-block">
                      Please enter the inherited storage start date
                    </p>
                  </div>
                  <div class="col-lg-8">
                    <datepicker
                      format="dd/MM/yyyy"
                      :value="form.inherited_storage_start_at"
                      name="inherited_storage_start_at"
                      v-on:selected="setInheritedStorageStartDate"
                      v-on:input="changeHandler"
                      input-class="form-control"
                      placeholder="dd/mm/yyyy"
                    ></datepicker>
                    <span
                      class="text-danger"
                      v-text="form.errors.get('inherited_storage_start_at')"
                      v-if="form.errors.has('inherited_storage_start_at')"
                    ></span>
                  </div>
                </div>

                <div
                  class="form-group has-helper"
                  :class="{
                    'has-error': form.errors.has('inherited_storage_end_at')
                  }"
                >
                  <div class="col-md-4">
                    <label class="control-label"
                      >Inherited storage end date:</label
                    >
                    <p class="help-block">
                      Please enter the inherited storage end date
                    </p>
                  </div>
                  <div class="col-lg-8">
                    <datepicker
                      format="dd/MM/yyyy"
                      :value="form.inherited_storage_end_at"
                      name="inherited_storage_end_at"
                      v-on:selected="setInheritedStorageEndDate"
                      v-on:input="changeHandler"
                      input-class="form-control"
                      placeholder="dd/mm/yyyy"
                    ></datepicker>
                    <span
                      class="text-danger"
                      v-text="form.errors.get('inherited_storage_end_at')"
                      v-if="form.errors.has('inherited_storage_end_at')"
                    ></span>
                  </div>
                </div>

                <currency-input
                  name="inherited_storage_costs"
                  label="Inherited Storage Costs"
                  v-model="form.inherited_storage_costs"
                  helper="Please enter the inherited storage cost"
                  :show-error="form.errors.has('inherited_storage_costs')"
                  :error-message="form.errors.get('inherited_storage_costs')"
                ></currency-input>

                <fieldset>
                  <legend>
                    Collected From Address
                    <small class="text-muted">
                      - Enter the collected from address
                    </small>
                  </legend>
                  <address-lookup
                    :address="inheritedStorageCollectedFromAddress"
                    v-on:address="setInheritedStorageCollectedFromAddress"
                  ></address-lookup>
                </fieldset>

                <company-select
                  id="inherited-storage-company-select"
                  :types="companyTypes"
                  :company="getInheritedStorageCompany"
                  ref="inheritedStorageCompany"
                ></company-select>
              </template>
            </fieldset>
          </div>
        </div>
      </div>
      <div class="card-footer text-right" v-if="!readonly">
        <form-button :indicator="form.processing()" v-on:clicked="submit">
          Save
        </form-button>
      </div>
    </fieldset>
  </form>
</template>

<script>
import Company from './../Shared/Company';
import CurrencyInput from '@/components/Generic/Form/CurrencyInput';

export default {
  props: {
    incident: {
      type: String,
      required: true
    },
    selectedService: {
      type: Object,
      required: false,
      default: null
    },
    readonly: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  components: {
    CurrencyInput,
    'company-select': Company
  },
  methods: {
    mount() {
      this.getProtocolTariff().then(() => {
        if (this.recovery?.identifier) {
          this.setRecovery(this.recovery);
        } else {
          this.setProtocolStorageRates();
        }
      });
    },

    setRecovery(recovery) {
      this.recovery_exists = true;
      this.hasInheritedRecovery = this.checkInheritedRecovery(recovery);
      this.hasInheritedStorage = this.checkInheritedStorage(recovery);

      this.form.inherited_storage_start_at =
        recovery.inherited_storage_start_at;
      this.form.inherited_storage_end_at = recovery.inherited_storage_end_at;
      this.form.inherited_storage_costs = recovery.inherited_storage_costs;
      this.form.inherited_storage_address_line_one =
        recovery.inherited_storage_address_line_one;
      this.form.inherited_storage_address_line_two =
        recovery.inherited_storage_address_line_two;
      this.form.inherited_storage_city = recovery.inherited_storage_city;
      this.form.inherited_storage_postcode =
        recovery.inherited_storage_postcode;
      this.form.inherited_storage_company_id =
        recovery.inherited_storage_company_id;
      this.form.inherited_storage_company_name =
        recovery.inherited_storage_company_name;
      this.form.inherited_storage_company_email_address =
        recovery.inherited_storage_company_email_address;
      this.form.inherited_storage_company_telephone_number =
        recovery.inherited_storage_company_telephone_number;
      this.form.inherited_storage_company_address_line_one =
        recovery.inherited_storage_company_address_line_one;
      this.form.inherited_storage_company_address_line_two =
        recovery.inherited_storage_company_address_line_two;
      this.form.inherited_storage_company_city =
        recovery.inherited_storage_company_city;
      this.form.inherited_storage_company_postcode =
        recovery.inherited_storage_company_postcode;
      this.form.inherited_recovery_at = recovery.inherited_recovery_at;
      this.form.inherited_recovery_cost = recovery.inherited_recovery_cost;
      this.form.inherited_recovery_address_line_one =
        recovery.inherited_recovery_address_line_one;
      this.form.inherited_recovery_address_line_two =
        recovery.inherited_recovery_address_line_two;
      this.form.inherited_recovery_city = recovery.inherited_recovery_city;
      this.form.inherited_recovery_postcode =
        recovery.inherited_recovery_postcode;
      this.form.inherited_recovery_company_id =
        recovery.inherited_recovery_company_id;
      this.form.inherited_recovery_company_name =
        recovery.inherited_recovery_company_name;
      this.form.inherited_recovery_company_email_address =
        recovery.inherited_recovery_company_email_address;
      this.form.inherited_recovery_company_telephone_number =
        recovery.inherited_recovery_company_telephone_number;
      this.form.inherited_recovery_company_address_line_one =
        recovery.inherited_recovery_company_address_line_one;
      this.form.inherited_recovery_company_address_line_two =
        recovery.inherited_recovery_company_address_line_two;
      this.form.inherited_recovery_company_city =
        recovery.inherited_recovery_company_city;
      this.form.inherited_recovery_company_postcode =
        recovery.inherited_recovery_company_postcode;
      this.form.storage_start_at = recovery.storage_start_at;
      this.form.storage_end_at = recovery.storage_end_at;
      this.form.storage_daily_rate = recovery.storage_daily_rate;
      // Storage cap must be an integer to repopulate the currency component correctly, here we ensure string values are
      // converted to integers
      this.form.storage_cap = recovery.storage_cap
        ? parseInt(recovery.storage_cap)
        : null;
      this.form.storage_address_line_one = recovery.storage_address_line_one;
      this.form.storage_address_line_two = recovery.storage_address_line_two;
      this.form.storage_city = recovery.storage_city;
      this.form.storage_postcode = recovery.storage_postcode;
      this.form.storage_company_id = recovery.storage_company_id;
      this.form.storage_company_name = recovery.storage_company_name;
      this.form.storage_company_email_address =
        recovery.storage_company_email_address;
      this.form.storage_company_telephone_number =
        recovery.storage_company_telephone_number;
      this.form.storage_company_address_line_one =
        recovery.storage_company_address_line_one;
      this.form.storage_company_address_line_two =
        recovery.storage_company_address_line_two;
      this.form.storage_company_city = recovery.storage_company_city;
      this.form.storage_company_postcode = recovery.storage_company_postcode;
      this.form.recovery_at = recovery.recovery_at;
      this.form.recovery_cost = recovery.recovery_cost;
      this.form.recovery_company_id = recovery.recovery_company_id;
      this.form.recovery_company_name = recovery.recovery_company_name;
      this.form.recovery_company_email_address =
        recovery.recovery_company_email_address;
      this.form.recovery_company_telephone_number =
        recovery.recovery_company_telephone_number;
      this.form.recovery_company_address_line_one =
        recovery.recovery_company_address_line_one;
      this.form.recovery_company_address_line_two =
        recovery.recovery_company_address_line_two;
      this.form.recovery_company_city = recovery.recovery_company_city;
      this.form.recovery_company_postcode = recovery.recovery_company_postcode;
      this.form.admin_fee = recovery.admin_fee;
    },

    setProtocolStorageRates() {
      this.form.storage_daily_rate = this.protocolTariff?.storage_daily_rate;
      this.form.storage_cap = this.protocolTariff?.storage_cap;
    },

    setAgentAddress(address) {
      this.form.agent_address_line_one = address.address_line_one;
      this.form.agent_address_line_two = address.address_line_two;
      this.form.agent_city = address.city;
      this.form.agent_postcode = address.postcode;
    },
    setInheritedStorageStartDate(value) {
      this.form.inherited_storage_start_at = value;
    },
    setInheritedStorageEndDate(value) {
      this.form.inherited_storage_end_at = value;
    },
    setInheritedRecoveryDate(value) {
      this.form.inherited_recovery_at = value;
    },
    setStorageStartDate(value) {
      this.form.storage_start_at = value;
    },
    setStorageEndDate(value) {
      this.form.storage_end_at = value;
    },
    setInheritedStorageCompany(company) {
      this.form.inherited_storage_company_id = company.company_id;
      this.form.inherited_storage_company_name = company.name;
      this.form.inherited_storage_company_email_address = company.email_address;
      this.form.inherited_storage_company_telephone_number =
        company.telephone_number;
      this.form.inherited_storage_company_address_line_one =
        company.address_line_one;
      this.form.inherited_storage_company_address_line_two =
        company.address_line_two;
      this.form.inherited_storage_company_city = company.city;
      this.form.inherited_storage_company_postcode = company.postcode;
    },
    setInheritedStorageCollectedFromAddress(address) {
      this.form.inherited_storage_address_line_one = address.address_line_one;
      this.form.inherited_storage_address_line_two = address.address_line_two;
      this.form.inherited_storage_city = address.city;
      this.form.inherited_storage_postcode = address.postcode;
    },
    setStorageLocation(address) {
      this.form.storage_address_line_one = address.address_line_one;
      this.form.storage_address_line_two = address.address_line_two;
      this.form.storage_city = address.city;
      this.form.storage_postcode = address.postcode;
    },
    setInheritedRecoveryAddress(address) {
      this.form.inherited_recovery_address_line_one = address.address_line_one;
      this.form.inherited_recovery_address_line_two = address.address_line_two;
      this.form.inherited_recovery_city = address.city;
      this.form.inherited_recovery_postcode = address.postcode;
    },
    setInheritedRecoveryCompany(company) {
      this.form.inherited_recovery_company_id = company.company_id;
      this.form.inherited_recovery_company_name = company.name;
      this.form.inherited_recovery_company_email_address =
        company.email_address;
      this.form.inherited_recovery_company_telephone_number =
        company.telephone_number;
      this.form.inherited_recovery_company_address_line_one =
        company.address_line_one;
      this.form.inherited_recovery_company_address_line_two =
        company.address_line_two;
      this.form.inherited_recovery_company_city = company.city;
      this.form.inherited_recovery_company_postcode = company.postcode;
    },
    setStorageCompany(company) {
      this.form.storage_company_id = company.company_id;
      this.form.storage_company_name = company.name;
      this.form.storage_company_email_address = company.email_address;
      this.form.storage_company_telephone_number = company.telephone_number;
      this.form.storage_company_address_line_one = company.address_line_one;
      this.form.storage_company_address_line_two = company.address_line_two;
      this.form.storage_company_city = company.city;
      this.form.storage_company_postcode = company.postcode;
    },
    setRecoveryDate(value) {
      this.form.recovery_at = value;
    },
    setRecoveryCompany(company) {
      this.form.recovery_company_id = company.company_id;
      this.form.recovery_company_name = company.name;
      this.form.recovery_company_email_address = company.email_address;
      this.form.recovery_company_telephone_number = company.telephone_number;
      this.form.recovery_company_address_line_one = company.address_line_one;
      this.form.recovery_company_address_line_two = company.address_line_two;
      this.form.recovery_company_city = company.city;
      this.form.recovery_company_postcode = company.postcode;
    },
    checkInheritedRecovery(recovery) {
      return !!(
        recovery?.inherited_recovery_at ||
        recovery?.inherited_recovery_cost ||
        recovery?.inherited_recovery_address_line_one ||
        recovery?.inherited_recovery_address_line_two ||
        recovery?.inherited_recovery_city ||
        recovery?.inherited_recovery_postcode ||
        recovery?.inherited_recovery_company_id ||
        recovery?.inherited_recovery_company_name ||
        recovery?.inherited_recovery_company_email_address ||
        recovery?.inherited_recovery_company_telephone_number ||
        recovery?.inherited_recovery_company_address_line_one ||
        recovery?.inherited_recovery_company_address_line_two ||
        recovery?.inherited_recovery_company_city ||
        recovery?.inherited_recovery_company_postcode
      );
    },
    checkInheritedStorage(recovery) {
      return !!(
        recovery?.inherited_storage_start_at ||
        recovery?.inherited_storage_end_at ||
        recovery?.inherited_storage_costs ||
        recovery?.inherited_storage_address_line_one ||
        recovery?.inherited_storage_address_line_two ||
        recovery?.inherited_storage_city ||
        recovery?.inherited_storage_postcode ||
        recovery?.inherited_storage_company_id ||
        recovery?.inherited_storage_company_name ||
        recovery?.inherited_storage_company_email_address ||
        recovery?.inherited_storage_company_telephone_number ||
        recovery?.inherited_storage_company_address_line_one ||
        recovery?.inherited_storage_company_address_line_two ||
        recovery?.inherited_storage_company_city ||
        recovery?.inherited_storage_company_postcode
      );
    },
    toggleInheritedRecovery() {
      this.hasInheritedRecovery = !this.hasInheritedRecovery;

      if (!this.hasInheritedRecovery) {
        this.form.inherited_recovery_at = null;
        this.form.inherited_recovery_cost = null;
        this.form.inherited_recovery_address_line_one = null;
        this.form.inherited_recovery_address_line_two = null;
        this.form.inherited_recovery_city = null;
        this.form.inherited_recovery_postcode = null;
        this.form.inherited_recovery_company_id = null;
        this.form.inherited_recovery_company_name = null;
        this.form.inherited_recovery_company_email_address = null;
        this.form.inherited_recovery_company_telephone_number = null;
        this.form.inherited_recovery_company_address_line_one = null;
        this.form.inherited_recovery_company_address_line_two = null;
        this.form.inherited_recovery_company_city = null;
        this.form.inherited_recovery_company_postcode = null;
      }
    },
    toggleInheritedStorage() {
      this.hasInheritedStorage = !this.hasInheritedStorage;

      if (!this.hasInheritedStorage) {
        this.form.inherited_storage_start_at = null;
        this.form.inherited_storage_end_at = null;
        this.form.inherited_storage_costs = null;
        this.form.inherited_storage_address_line_one = null;
        this.form.inherited_storage_address_line_two = null;
        this.form.inherited_storage_city = null;
        this.form.inherited_storage_postcode = null;
        this.form.inherited_storage_company_id = null;
        this.form.inherited_storage_company_name = null;
        this.form.inherited_storage_company_email_address = null;
        this.form.inherited_storage_company_telephone_number = null;
        this.form.inherited_storage_company_address_line_one = null;
        this.form.inherited_storage_company_address_line_two = null;
        this.form.inherited_storage_company_city = null;
        this.form.inherited_storage_company_postcode = null;
      }
    },
    changeHandler() {
      if (!this.data_entered) {
        this.data_entered = true;
      }
      this.$emit('unsaved-data', this.data_entered);
    },
    submit() {
      if (this.readonly) return;
      if (this.$refs.inheritedStorageCompany?.form) {
        this.setInheritedStorageCompany(
          this.$refs.inheritedStorageCompany.form
        );
      }

      if (this.$refs.inheritedRecoveryCompany?.form) {
        this.setInheritedRecoveryCompany(
          this.$refs.inheritedRecoveryCompany.form
        );
      }

      if (this.$refs.storageCompany?.form) {
        this.setStorageCompany(this.$refs.storageCompany.form);
      }

      if (this.$refs.recoveryCompany?.form) {
        this.setRecoveryCompany(this.$refs.recoveryCompany.form);
      }

      if (this.selectedService) {
        this.form.service_id = this.selectedService.id;
      }
      if (this.recovery_exists) {
        this.makeRequest('put');
        this.data_entered = false;
        this.$emit('unsaved-data', this.data_entered);
        return;
      }

      this.makeRequest('post');
      this.data_entered = false;
      this.$emit('unsaved-data', this.data_entered);
    },
    makeRequest(method) {
      this.form[method](`/incidents/${this.incident}/services/recovery`)
        .then(response => {
          if (!this.recovery_exists) {
            this.recovery_exists = true;
          }
          this.$store.commit('Incident/setVehicleRecovery', response);
          this.setRecovery(response);
          window.toastify.success(
            'Saved',
            'The recovery was saved successfully!'
          );
        })
        .catch(error => {
          window.toastify.error(
            'Error',
            "We couldn't save the recovery - please try again."
          );
        });
    },

    getProtocolTariff() {
      return window.Ajax.get(`/incidents/${this.incident}?parts=protocolTariff`)
        .then(response => {
          this.protocolTariff = response.data.protocolTariff || {};
        })
        .catch(error => {
          window.toastify.error(
            'Error',
            'Sorry, there was an issue getting the tariff'
          );
        });
    }
  },
  data() {
    return {
      form: new window.Form(
        {
          service_id: null,
          inherited_storage_start_at: null,
          inherited_storage_end_at: null,
          inherited_storage_costs: null,
          inherited_storage_address_line_one: null,
          inherited_storage_address_line_two: null,
          inherited_storage_city: null,
          inherited_storage_postcode: null,
          inherited_storage_company_id: null,
          inherited_storage_company_name: null,
          inherited_storage_company_email_address: null,
          inherited_storage_company_telephone_number: null,
          inherited_storage_company_address_line_one: null,
          inherited_storage_company_address_line_two: null,
          inherited_storage_company_city: null,
          inherited_storage_company_postcode: null,
          inherited_recovery_at: null,
          inherited_recovery_cost: null,
          inherited_recovery_address_line_one: null,
          inherited_recovery_address_line_two: null,
          inherited_recovery_city: null,
          inherited_recovery_postcode: null,
          inherited_recovery_company_id: null,
          inherited_recovery_company_name: null,
          inherited_recovery_company_email_address: null,
          inherited_recovery_company_telephone_number: null,
          inherited_recovery_company_address_line_one: null,
          inherited_recovery_company_address_line_two: null,
          inherited_recovery_company_city: null,
          inherited_recovery_company_postcode: null,
          storage_start_at: null,
          storage_end_at: null,
          storage_daily_rate: null,
          storage_cap: null,
          storage_address_line_one: null,
          storage_address_line_two: null,
          storage_city: null,
          storage_postcode: null,
          storage_company_id: null,
          storage_company_name: null,
          storage_company_email_address: null,
          storage_company_telephone_number: null,
          storage_company_address_line_one: null,
          storage_company_address_line_two: null,
          storage_company_city: null,
          storage_company_postcode: null,
          recovery_at: null,
          recovery_cost: null,
          recovery_company_id: null,
          recovery_company_name: null,
          recovery_company_email_address: null,
          recovery_company_telephone_number: null,
          recovery_company_address_line_one: null,
          recovery_company_address_line_two: null,
          recovery_company_city: null,
          recovery_company_postcode: null,
          admin_fee: null
        },
        true
      ),
      recovery_exists: false,
      data_entered: false,
      companyTypes: ['recovery'],
      hasInheritedRecovery: false,
      hasInheritedStorage: false,
      protocolTariff: {}
    };
  },

  mounted() {
    this.mount();
  },
  computed: {
    recovery() {
      return this.$store.getters['Incident/vehicleRecovery'];
    },
    inheritedStorageCollectedFromAddress() {
      return {
        address_line_one: this.form.inherited_storage_address_line_one,
        address_line_two: this.form.inherited_storage_address_line_two,
        city: this.form.inherited_storage_city,
        postcode: this.form.inherited_storage_postcode
      };
    },
    inheritedRecoveryAddress() {
      return {
        address_line_one: this.form.inherited_recovery_address_line_one,
        address_line_two: this.form.inherited_recovery_address_line_two,
        city: this.form.inherited_recovery_city,
        postcode: this.form.inherited_recovery_postcode
      };
    },
    getInheritedStorageCompany() {
      return {
        company_id: this.form.inherited_storage_company_id,
        name: this.form.inherited_storage_company_name,
        email_address: this.form.inherited_storage_company_email_address,
        telephone_number: this.form.inherited_storage_company_telephone_number,
        address_line_one: this.form.inherited_storage_company_address_line_one,
        address_line_two: this.form.inherited_storage_company_address_line_two,
        city: this.form.inherited_storage_company_city,
        postcode: this.form.inherited_storage_company_postcode
      };
    },
    getInheritedRecoveryCompany() {
      return {
        company_id: this.form.inherited_recovery_company_id,
        name: this.form.inherited_recovery_company_name,
        email_address: this.form.inherited_recovery_company_email_address,
        telephone_number: this.form.inherited_recovery_company_telephone_number,
        address_line_one: this.form.inherited_recovery_company_address_line_one,
        address_line_two: this.form.inherited_recovery_company_address_line_two,
        city: this.form.inherited_recovery_company_city,
        postcode: this.form.inherited_recovery_company_postcode
      };
    },
    storageLocation() {
      return {
        address_line_one: this.form.storage_address_line_one,
        address_line_two: this.form.storage_address_line_two,
        city: this.form.storage_city,
        postcode: this.form.storage_postcode
      };
    },
    getStorageCompany() {
      return {
        company_id: this.form.storage_company_id,
        name: this.form.storage_company_name,
        email_address: this.form.storage_company_email_address,
        telephone_number: this.form.storage_company_telephone_number,
        address_line_one: this.form.storage_company_address_line_one,
        address_line_two: this.form.storage_company_address_line_two,
        city: this.form.storage_company_city,
        postcode: this.form.storage_company_postcode
      };
    },
    getRecoveryCompany() {
      return {
        company_id: this.form.recovery_company_id,
        name: this.form.recovery_company_name,
        email_address: this.form.recovery_company_email_address,
        telephone_number: this.form.recovery_company_telephone_number,
        address_line_one: this.form.recovery_company_address_line_one,
        address_line_two: this.form.recovery_company_address_line_two,
        city: this.form.recovery_company_city,
        postcode: this.form.recovery_company_postcode
      };
    }
  },

  watch: {
    recovery(recovery) {
      if (recovery?.identifier) {
        this.setRecovery(recovery);
      }
    }
  }
};
</script>
